export default function Tag({ children, variant = 'default' }) {
  if (variant === 'filled') return <span className="tag-filled">{children}</span>;
  if (variant === 'ghost')  return <span className="tag-ghost">{children}</span>;
  return <span className="label-tag">{children}</span>;
}
